var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"zoom-img-components clear"},[_c('div',{directives:[{name:"viewer",rawName:"v-viewer"}],staticClass:"img-item"},_vm._l((_vm.urlList),function(src){return _c('img',{key:src,attrs:{"src":src}})}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }